// eslint-disable-next-line import/no-unassigned-import
import 'unfetch/polyfill';
import morphdom from 'morphdom';

const errorMessagePartial =
	`<div className="eds-c-status-message eds-c-status-message--warning">
		<div className="eds-c-status-message__content-icon">
			<svg  aria-hidden="true" width="16" height="16" className="eds-c-status-message__icon">
				<use href="/static/img/svg-sprite.svg#info"/>
			</svg>
		</div>
		<div className="eds-c-status-message__text">
			<span>We experience some technical problems, please try refreshing the page.</span>
		</div>
	</div>`;

class CounterReports {
	constructor(config) {
		this.config = config;
		this.DateValidation = this.config.dateValidation;
		this._sendDataAndUpdateUI = this._sendDataAndUpdateUI.bind(this);
		this._preventSubmit = this._preventSubmit.bind(this);
		this.submitRequested = false;
		this.firstInitFlag = '?init=true';
	}

	// this is needed in order to be able to add and
	// rerender naturejr5 static years template out of the form
	get formWrapper() {
		return document.querySelector(this.config.counterReportsWrapperSelector);
	}

	get formElement() {
		return document.querySelector(this.config.counterReportsForm);
	}

	fetchUrl() {
		return this.formElement.getAttribute('data-api-url');
	}

	_fetchData(url) {
		return fetch(url, {
			credentials: 'include'
		})
			.then(this._handleState)
			.then(response =>
				response.text())
			.then(data => {
				return data;
			}).catch(error => {
				console.error(`error fetching from url ${url}: ${error.message}`, error);
			});
	}

	_handleState(response) {
		if (response.ok) {
			return response;
		}

		const error = new Error(response.statusText);
		return Promise.reject(error);
	}

	_diffForm(formBefore, fetchedForm) {
		// rendering after fecthing on change
		return new Promise((resolve, reject) => {
			resolve(morphdom(formBefore, fetchedForm, {
				onBeforeElUpdated(formBefore, fetchedForm) {
					// This avoids traversing through the entire subtree when they are equal
					if (formBefore.isEqualNode(fetchedForm)) {
						return false;
					}
					return true;
				}
			}));
		});
	}

	// create the url to fetch from
	_formatUrl(urlString, parameters) {
		const requestParameters = new URLSearchParams(parameters).toString();
		return `${urlString}?${requestParameters}`;
	}

	_formDataToObj(formElement) {
		const formData = new FormData(formElement);
		const formDataObject = {};

		for (const [key, value] of formData.entries()) {
			formDataObject[key] = value;
		}
		return formDataObject;
	}

	_preventSubmit(event) {
		event.preventDefault();
		this.submitRequested = true;

		this._sendDataAndUpdateUI();
	}

	_sendDataAndUpdateUI() {
		const formDataObject = this._formDataToObj(this.formElement);
		const finalUrl = this._formatUrl(this.fetchUrl(), formDataObject);

		this._fetchData(finalUrl).then(data => {
			const errorExists = data.includes('aria-invalid="true"');
			// if the intention was to submit the form &
			// the fetch shows us that it's valid response then we resubmit
			if (this.submitRequested && !errorExists) {
				this.formElement.submit();
			}
			this._renderForm(data);
			this.submitRequested = false;
		});
	}

	_renderForm(data) {
		/*	const dateValidate = new this.DateValidation({
			startDateId: 'date-from',
			endDateId: 'date-to',
			dateFormat: 'year-month'
		});
		dateValidate.init(); */
		if (data) {
			this._diffForm(this.formWrapper, data);
		} else {
			this.formElement.innerHTML = errorMessagePartial;
		}
	}

	init() {
		if (this.formElement === null || this.formElement === undefined) {
			return;
		}

		this.formElement.addEventListener('change', this._sendDataAndUpdateUI);
		this.formElement.addEventListener('submit', this._preventSubmit);

		this._fetchData(this.fetchUrl() + this.firstInitFlag).then(data => {
			this._renderForm(data);
		});
	}
}

export default CounterReports;
